import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
	return (
		<div className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
			<div className="absolute inset-0 bg-grid-white/[0.2] bg-grid-16" />
			<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
				<h1 className="text-4xl md:text-6xl font-bold mb-6">勉強会</h1>
				<p className="text-xl md:text-2xl mb-8 text-blue-100">
					実践的なスキルを身につける、
					<br className="hidden md:block" />
					仲間と学び合う場所
				</p>
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Button
						asChild
						size="lg"
						className="bg-white text-blue-600 hover:bg-blue-50"
					>
						<Link to="/study-groups/schedule">スケジュールを見る</Link>
					</Button>
					<Button asChild size="lg" variant="outline" className="text-white">
						<Link to="/study-groups/archive">過去の勉強会</Link>
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Hero;
